<template>

  <div :class="modalClass"><b-container>

    <b-row><b-col>
      <div v-if="jobType=='input'">
        <br/><h2>PCカメラ映像画面</h2><br/>
      </div>
    </b-col></b-row>

    <b-row><b-col>
    <div v-if="jobType=='predict'"><strong>PCカメラ映像画面</strong></div>
    <div class=video-div-width>
      <video id="draw_video" class="video-cls" />
      <div class="relativecls inlineblkcls"><canvas id="draw_canvas28" width="28" height="28"></canvas>
        <div class="aicanvas-word"><strong>AI利用<br/>サイズ</strong></div>
      </div>
    </div>
    </b-col><b-col v-show="renzoku">
      <div id="canvas_cont" class="canvas-cont-cls relativecls"></div>
      <div class="canvas-cont-word">連続取得した画像表示：{{renzokuCount}}枚</div>
    </b-col></b-row>

    <b-row><b-col>
    <div id="answer" v-if="jobType=='input'" class="btngwidth">
      <br/>
      <b-button variant="outline-primary" class="btnw" @click="cancelImg">Cancel</b-button>
      <div class="inlineblkcls relativecls">
        <b-button variant="outline-primary" class="btnw" @click="setImg">Set</b-button>
        <div class="renCheck">
          <b-form-checkbox v-model="renzoku" size="sm" name="check-button" switch switch-variant="outline-primary" v-on:change="renChkChange">
          連続<b>{{renzokuWord}}</b><span class="verysFont">(秒)</span>
          </b-form-checkbox>
          <b-form-spinbutton v-model="renSpinval" min="0.2" max="100" step="0.2" size="sm" inline :disabled="renSpinDisabled"></b-form-spinbutton>
        </div>
        <div class="getRenzokuCls">
        <b-button variant="outline-primary" class="btnw" v-if="renzoku" @click="getRenzoku">{{getRenzokuBtn}}</b-button>
        </div>
      </div>
      <br/><br/>
    </div></b-col></b-row>
    <b-row><b-col><div>
      <div id="message_window">
        <div class="dispmes">{{dispMessage}}</div>
      </div>
      <div v-if="jobType=='input'"><br/></div>
    </div>
    </b-col></b-row>

  </b-container></div>

</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'inmodalpc',
  props: {
    jobType: { type: String, default: 'input' }
  },
  data () {
    return {
      m_in: 0,
      m_img: 0,
      dispMessage: 'PCカメラの映像を利用します。',
      width: 28,
      height: 28,
      video: null,
      canvas: null,
      ctx: null,
      canvascont: null,
      videoTimer: null,
      renzokuTimer: null,
      renzoku: false,
      renSpinval: 0.6,
      renzokuCount: 0,
      renzokuWord: 'OFF',
      renSpinDisabled: false,
      getRenzokuFlag: false
    }
  },
  computed: {
    ...mapState([ 'setModals' ]),
    modalClass () {
      if (this.renzoku) {
        return 'modal-contentmax modal-pad2'
      } else {
        if (this.jobType === 'predict') {
          return 'widthmax'
        } else {
          return 'modal-content modalLightGray modal-pad1'
        }
      }
    },
    getRenzokuBtn () {
      if (this.getRenzokuFlag) {
        return '停止'
      } else {
        return '連続取得'
      }
    }
  },
  methods: {
    renChkChange () {
      if (this.renzoku) {
        this.renzokuWord = 'OFF'
        this.renSpinDisabled = true
        this.dispMessage = 'PCカメラの映像を利用します。'
      } else {
        this.renzokuWord = 'ON'
        this.renSpinDisabled = false
        this.dispMessage = '「連続取得」で画像を取得できます。取得画像を確認し「Set」して下さい。'
      }
    },
    update_message: function (str) {
      this.dispMessage = str
    },
    // --------------------PC-Camera関連--------------------
    videoStart: function () {
      /** カメラ設定 */
      const constraints = {
        audio: false,
        video: {
          width: 356,
          height: 288,
          facingMode: 'user' // フロントカメラを利用する
          // facingMode: { exact: "environment" }  // リアカメラを利用する場合
        }
      }
      /** カメラを<video>と同期 */
      navigator.mediaDevices.getUserMedia(constraints)
        .then((stream) => {
          this.video.srcObject = stream
          this.video.onloadedmetadata = (e) => {
            this.video.play()
            // Vue.jsはsetIntervalの呼出関数に()引数を取れない模様
            this.videoTimer = setInterval(this.updateCanvas, 450)
          }
        })
        .catch((err) => {
          console.log(err.name + ': ' + err.message)
        })
    },
    updateCanvas () {
      this.ctx.drawImage(this.video, 0, 0, this.width, this.height)
    },
    // --------------------PC-Camera関連--------------------
    setImg: function () {
      this.dispMessage = '処理中です。しばらくお待ち下さい...'
      if (this.renzoku) {
        for (var i = 1; i <= this.renzokuCount; i++) {
          const gid = 'gcanvas' + String(i)
          const gcanvas = document.getElementById(gid)
          this.$store.dispatch('setImage', {
            s_in: this.m_in,
            s_img: i,
            s_data: gcanvas.toDataURL()
          })
        }
      } else {
        this.video.pause() // 映像を停止
        // this.ctx.drawImage(this.video, 0, 0, this.width, this.height)
        var pixels = this.changeGrayscale(this.ctx.getImageData(0, 0, this.width, this.height))
        this.ctx.putImageData(pixels, 0, 0)
        this.$store.dispatch('setImage', {
          s_in: this.m_in,
          s_img: this.m_img,
          s_data: this.canvas.toDataURL()
        })
        /* this.$store.dispatch('setAidata', {
          s_in: this.m_in,
          s_img: this.m_img,
          s_aid: this.ctx.getImageData(0, 0, this.width, this.height).data
        }) */
      }
      // 画面を閉じる
      this.cancelImg()
    },
    getRenzoku () {
      this.getRenzokuFlag = !this.getRenzokuFlag
      // 映像を連続受信
      if (this.getRenzokuFlag) {
        // 開始時の初期処理
        this.renzokuCount = 0
        while (this.canvascont.lastChild) {
          this.canvascont.removeChild(this.canvascont.lastChild)
        }
        // Canvas保存処理
        this.getRenzokuCanvas()
      // 映像取得をSTOP
      } else {
        clearInterval(this.renzokuTimer)
      }
    },
    getRenzokuCanvas () {
      const gcanvas = document.createElement('canvas')
      const gctx = gcanvas.getContext('2d')
      gcanvas.width = 28
      gcanvas.height = 28
      gcanvas.id = 'gcanvas' + String(this.renzokuCount + 1)
      gcanvas.style = 'margin: 2px; outline: black 1px solid;'
      var pixels = this.changeGrayscale(this.ctx.getImageData(0, 0, this.width, this.height))
      gctx.putImageData(pixels, 0, 0)
      this.canvascont.appendChild(gcanvas)
      this.renzokuCount++
      this.renzokuTimer = setTimeout(this.getRenzokuCanvas, this.renSpinval * 1000)
    },
    cancelImg () {
      this.video.pause()
      clearInterval(this.renzokuTimer)
      clearInterval(this.videoTimer)
      this.$store.dispatch('dispModalChg', {
        s_in: this.m_in,
        s_img: this.m_img
      })
    },
    changeGrayscale (pixels) {
      for (var y = 0; y < pixels.height; y++) {
        for (var x = 0; x < pixels.width; x++) {
          var i = (y * 4) * pixels.width + x * 4
          var rgb = parseInt((pixels.data[i] + pixels.data[i + 1] + pixels.data[i + 2]) / 3, 10)
          pixels.data[i] = rgb
          pixels.data[i + 1] = rgb
          pixels.data[i + 2] = rgb
          pixels.data[i + 3] = 255
        }
      }
      return pixels
    }
  },
  created () {
    this.m_in = this.setModals.modalin // Getterはdata()やcomputed()では使えないのでCreate時に代入
    this.m_img = this.setModals.modalimg // Getterはdata()やcomputed()では使えないのでCreate時に代入
    // console.log('modalKit:' + this.m_in + ':' + this.m_img)
  },
  mounted () { // Mount後でないとDOMが取得できない
    this.video = document.getElementById('draw_video')
    this.canvas = document.getElementById('draw_canvas28')
    this.ctx = this.canvas.getContext('2d')
    this.canvascont = document.getElementById('canvas_cont') // v-ifだと取得できないのでv-showで非表示
    this.videoStart()
    /* this.video.addEventListener('timeupdate', function () {
      this.ctx.drawImage(this.video, 0, 0, this.width, this.height)
    }, true) */
  }
}
</script>

<style scoped>
.modal-contentmax{
  z-index:101;
  width:95%;
  padding: 5px;
  border: 0;
  background:#eee;
  border-radius: 10px;
}
.modalLightGray {
  background: #eee;
}
.modal-pad1 {
  padding: 10px 0 10px 0;
}
.modal-pad2 {
  padding: 10px 0 10px 30px;
}
canvas {
  position: relative;
  border: 1px solid #000;
  background: #000;
}
.aicanvas-word {
  position: absolute;
  top: -22px;
  right: -4px;
  font-size: 70%;
  line-height: 100%;
}
.video-div-width {
  width: 400px;
  margin: 0 auto;
}
.video-cls {
  position: relative;
  align-self: center;
  width: 356px;
  height: 288px;
  background: #000;
}
.dispmes {
  font: outline;
  color: red;
}
.btngwidth {
  width: 350px; /* 2button 250px*/
  padding: 0 100px 0 0;
  margin: 0 AUTO;
}
.renCheck {
  position: absolute;
  text-align: center;
  width: 123px;
  top: -13px;
  left: 120px
}
.getRenzokuCls {
  position: absolute;
  text-align: center;
  width: 123px;
  top: 0px;
  left: 240px
}
.verysFont {
  font-size: 80%;
}
div.container, div.col {
  max-width: 97%;
  margin: 0;
  padding: 0;
}
.canvas-cont-cls {
  width : -webkit-calc((100vw * 0.95) - 500px) ;
  width : calc((100vw * 0.95) - 500px) ;
  height: 288px;
  max-height: 300px;
  border: 1px solid #666666;
  background-color:#ddd;
  padding: 0;
  margin: 0 0 0 5px;
  overflow: auto;
}
.canvas-cont-word {
  z-index:1001;
  position: absolute;
  top: -20px;
  left : -webkit-calc(((100vw * 0.95) - 500px - 200px) / 2);
  left : calc(((100vw * 0.95) - 500px - 200px) / 2);
}
</style>



// WEBPACK FOOTER //
// src/components/InModalPc.vue